import React, { useState } from "react";
import base from "../base.js";

import "@firebase/firestore";

import "simplebar/dist/simplebar.min.css";

import * as Icon from "react-bootstrap-icons";
import StatusSetter from "./EkgList/statusSetter";
import { BrowserRouter as Router, Route, useHistory } from "react-router-dom";
import { Spinner } from "react-spinners-css";

const EkgList = () => {
  const [requests, setRequests] = React.useState([]);

  const [filter, setFilter] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(13);
  const [pending, setPending] = useState(false);
  const history = useHistory();

  React.useEffect(() => {
    const fetchData = async () => {
      const db = base.firestore();
      const date = await db.collection("requests").orderBy("createdAt", "desc");

      date.onSnapshot((data) => {
        if (filter === "all") {
          setRequests(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
        } else {
          setRequests(
            data.docs
              .filter((doc) => doc.data().status === filter)
              .map((doc) => ({ ...doc.data(), id: doc.id }))
          );
        }
      });
    };

    fetchData();
  }, [filter]);

  //pagination variables
  const indexOfLastReq = currentPage * postsPerPage;
  const indexOfFirstReq = indexOfLastReq - postsPerPage;
  const currentReqs = requests.slice(indexOfFirstReq, indexOfLastReq);

  const lastPageIndex = Math.ceil(requests.length / postsPerPage);

  const simplePaging = () => {
    return (
      <div className="pagineButtons d-flex justify-content-center">
        {currentPage != 1 ? (
          <button
            className="btn btn-dark mx-3 pagineBarLeft navButton"
            onClick={() => setCurrentPage(1)}
          >
            <Icon.ArrowBarLeft color="white" size={20} />
          </button>
        ) : (
          <button
            className="btn btn-dark  mx-3 pagineBarLeft navButton"
            disabled
          >
            <Icon.ArrowBarLeft color="white" size={20} />
          </button>
        )}
        {currentPage > 1 ? (
          <button
            className="btn btn-dark mx-3 pagineLeft navButton"
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            <Icon.ArrowLeft color="white" size={20} />
          </button>
        ) : (
          <button className="btn btn-dark mx-3 pagineLeft navButton" disabled>
            <Icon.ArrowLeft color="white" size={20} />
          </button>
        )}
        {currentPage < lastPageIndex ? (
          <button
            className="btn btn-dark mx-3 pagineRight navButton"
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            <Icon.ArrowRight color="white" size={20} />
          </button>
        ) : (
          <button className="btn btn-dark mx-3 pagineRight navButton" disabled>
            <Icon.ArrowRight color="white" size={20} />
          </button>
        )}
        {currentPage < lastPageIndex ? (
          <button
            className="btn btn-dark mx-3 pagineBarRight navButton"
            onClick={() => setCurrentPage(lastPageIndex)}
          >
            <Icon.ArrowBarRight color="white" size={20} />
          </button>
        ) : (
          <button
            className="btn btn-dark mx-3 pagineBarRight navButton"
            disabled
          >
            <Icon.ArrowBarRight color="white" size={20} />
          </button>
        )}
      </div>
    );
  };

  const calculateBlob = async (blob) => {
    var buffer = blob.toUint8Array().buffer;
    var floatArr = new Float64Array(buffer);

    return floatArr;
  };

  const push = (
    mStatus,
    mRequestId,
    mFinalArr,
    mSampling,
    mFinalResult,
    mResultId
  ) => {
    history.push({
      pathname: "/badanie",
      state: {
        status: mStatus,
        id: mRequestId,
        blob: mFinalArr,
        sampling: mSampling,
        result: mFinalResult,
        resultId: mResultId,
      },
    });
  };

  const fetchSample = async (mSample, mStatus, mRequest) => {
    setPending(true);
    let finalArr = null;
    let sampling = null;
    let finalResult = null;
    let resultId = null;
    if (mSample != null) {
      let result = null;
      try {
        result = await mRequest.result.get();
      } catch {
        finalResult = null;
      } finally {
        if (result != null) {
          resultId = await result.id;
          finalResult = await result.data();
        }
      }

      const sampleData = await mSample.get();
      const mBlob = await sampleData.data().rawData;

      sampling = await sampleData.data().sampling;
      finalArr = await calculateBlob(mBlob);
    } else {
      console.log("No such document!");
    }

    if (finalArr != null) {
      setPending(false);
      push(mStatus, mRequest.id, finalArr, sampling, finalResult, resultId);
    }
  };

  const setDate = (seconds) => {
    const date = new Date(seconds.toDate()).toISOString().slice(0, 10);
    const time = new Date(seconds.toDate()).toUTCString().slice(17, 25);
    return date + " " + time;
  };

  if (pending) {
    return (
      <div className="elipsis-padding-box">
        <Spinner color="grey" />
      </div>
    );
  }

  let component = (status, samples, request) => {
    if (status == "submitted") {
      return (
        <button
          className="btn btn-success"
          onClick={() => fetchSample(samples, status, request)}
        >
          Badanie
        </button>
      );
    } else if (status == "done") {
      return (
        <button
          className="btn btn-success"
          onClick={() => fetchSample(samples, status, request)}
        >
          Badanie
        </button>
      );
    } else {
      return (
        <button className="btn btn-danger" disabled="true">
          Badanie
        </button>
      );
    }
  };

  return (
    <div className="container_Table">
      <div className="flexboxes">
        <div className="flexbox_listView">
          <div className="flexbox_controls">
            <div
              class="btn-group btn-group-lg d-flex align-items-center"
              role="group"
              aria-label="..."
            >
              <button
                type="button"
                class="btn btn-light"
                onClick={() => {
                  setFilter("all");
                  setCurrentPage(1);
                }}
              >
                <Icon.ArrowUpSquareFill
                  color="royalblue"
                  size={30}
                  className="mr-3"
                />
                Wszystkie
              </button>
              <button
                type="button"
                class="btn btn-light"
                onClick={() => {
                  setFilter("done");
                  setCurrentPage(1);
                }}
              >
                <Icon.CheckSquareFill
                  color="green"
                  size={30}
                  className="mr-3"
                />
                Zrobione
              </button>
              <button
                type="button"
                class="btn btn-light"
                onClick={() => {
                  setFilter("submitted");
                  setCurrentPage(1);
                }}
              >
                <Icon.UnlockFill color="black" size={30} className="mr-3" />
                Do Zrobienia
              </button>
              <button
                type="button"
                class="btn btn-light"
                onClick={() => {
                  setFilter("inProgress");
                  setCurrentPage(1);
                }}
              >
                <Icon.LockFill color="#ccc508" size={30} className="mr-3" />W
                toku
              </button>
              <button
                type="button"
                class="btn btn-light"
                onClick={() => setFilter("waitingForPayment")}
              >
                <Icon.CashStack color="#ad1818" size={30} className="mr-3" />
                Nie Opłacone
              </button>
              <button
                type="button"
                class="btn btn-light"
                onClick={() => setFilter("cancelled")}
              >
                <Icon.XOctagonFill color="#ad1818" size={30} className="mr-3" />
                Anulowane
              </button>
            </div>
          </div>
          <div className="flexbox_listOfReports">
            <div class="list-group">
              <table class="table table-striped table-bordered table-sm overflow-auto ">
                <thead className="thead-dark">
                  <tr className="listOfReports_tableLabel">
                    <th className="text-center" scope="col">
                      #
                    </th>
                    <th className="text-center" scope="col">
                      Data
                    </th>
                    <th className="text-center" scope="col">
                      Status
                    </th>
                    <th className="text-center" scope="col">
                      Urządzenie
                    </th>
                    <th className="text-center" scope="col">
                      Użytkownik
                    </th>
                    <th className="text-center" scope="col">
                      Badanie
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {currentReqs.map((request, i = 0) => (
                    <tr key={request.id}>
                      <td className="text-center align-middle ">{i + 1}</td>
                      <td className="text-center align-middle">
                        {setDate(request.createdAt)}
                      </td>
                      <td className="text-center align-middle">
                        <StatusSetter status={request.status}></StatusSetter>
                      </td>
                      <td className="text-center align-middle ">
                        {request.source}
                      </td>
                      <td className="text-center align-middle">
                        {request.ownerID}
                      </td>
                      <td className="text-center align-middle">
                        {component(request.status, request.samples, request)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {simplePaging()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EkgList;
